import { CommonModule } from '@angular/common';
  import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import { GetPlanMasterByIdResponse, PlanBreakUpCalculationResponse, PlanMasterServices, SubscriptionById, UpgradePlanBreakUpResponse } from '@fitness-force/models';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { TranslateModule } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'upgrade-membership-info',
  templateUrl: './upgrade-membership-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule, 
    DividerModule, 
    SkeletonModule,
    StyleClassModule,
    CurrencyformatPipe,
  TranslateModule
  ]
})
export class UpgradeMembershipInfoComponent implements OnInit {
  @Input("planMaster") planMaster: GetPlanMasterByIdResponse ={} as GetPlanMasterByIdResponse;
  @Input("fromSubscription") fromSubscription: SubscriptionById ={} as SubscriptionById;
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);
  @Input('subscriptionStartDate') subscriptionStartDate : Date;
  @Input('showInfo') showInfo$ :boolean = true;
  @Input('showCalculation') showCalculation$ :boolean = true;
  @Input('upgardePlanBreakUpResponse') upgardePlanBreakUpResponse$  = new BehaviorSubject<PlanBreakUpCalculationResponse>({} as PlanBreakUpCalculationResponse);// Observable<>; //UpgradePlanBreakUpResponse  = {} as UpgradePlanBreakUpResponse;

  UpgradeDate: Date = new Date();
  
  constructor(public authService:AuthSevices) { }

  ngOnInit(): void {
    this.UpgradeDate= new Date();
  }

  allServiceNameHtml(oData: GetPlanMasterByIdResponse): string {
    let serviceCategoryName: string[] = [];
    let serviceCategory: any[] = [];
    oData.recurring_services.forEach((oService: PlanMasterServices) => {
      if (serviceCategoryName.indexOf(oService.name_primary_language) == -1) {
        serviceCategoryName.push(oService.name_primary_language);
        serviceCategory.push({
          name: oService.name_primary_language,
          isBaseMembership: oService.is_base_membership,
        });
      }
    });

    let str: string = `{{First}} {{Others}}`;

    let other: string = '';
    let first: string = '';
    for (let i = 0; i < serviceCategory.length; i++) {
      if (i == 0)
        first =
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
      else
        other =
          other +
          '<br class="md:hidden"> + ' +
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
    }

    return str.replace('{{First}}', first).replace('{{Others}}', other);
  }
  
}
